import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-[#0a0a0b] flex items-center justify-center">
        <div className="animate-pulse text-amber-500">Yukleniyor...</div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/loft-yonetim-2026" replace />;
  }
  
  return children;
};

export default ProtectedRoute;
